module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "l-wrapper"
  }, [_c('div', {
    staticClass: "l-menu",
    class: {
      'close-menu': _vm.close
    },
    on: {
      "mouseover": _vm.openHover
    }
  }, [_c('component-header', {
    attrs: {
      "close": _vm.close
    }
  }), _vm._v(" "), _c('component-menu', {
    attrs: {
      "close": _vm.close
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-content",
    class: {
      'close-content': _vm.close
    },
    on: {
      "mouseover": _vm.closeHover
    }
  }, [(_vm.login.state == false) ? [_c('login-modal')] : _vm._e(), _vm._v(" "), _c('component-topnavi', {
    attrs: {
      "close": _vm.close
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "keep-alive": ""
    }
  }), _vm._v(" "), _c('component-footer', {
    attrs: {
      "close": _vm.close
    }
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53190621"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1376
// module chunks = 0